import { expVal } from '@atlassian/jira-feature-experiments';

const MergeBoardWorkflowsRelayProvider = {
	get(): boolean {
		return expVal('merge_board_workflows', 'enabled', false);
	},
};

export default MergeBoardWorkflowsRelayProvider;
